import type { DiagramPage } from '../../core/types';
import { parseCsv } from './orgCsv';

export interface DataCsvResult {
  page: DiagramPage;
  matched: number;
  unmatched: string[];
  fields: string[];
}

const RESERVED = new Set(['__proto__','prototype','constructor']);
function normalizeHeader(value: string) { return value.trim().toLocaleLowerCase('pt-BR').normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
function safeField(value: string) {
  const key = value.trim().replace(/[^A-Za-z0-9_.-]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 80);
  return key && !RESERVED.has(key) ? key : null;
}

export function bindDataCsv(page: DiagramPage, csv: string): DataCsvResult {
  const rows = parseCsv(csv); if (rows.length < 2) throw new Error('O CSV precisa ter cabeçalho e ao menos uma linha de dados.');
  const headers = rows[0].map((value) => value.trim());
  const normalized = headers.map(normalizeHeader);
  const keyIndex = normalized.findIndex((key) => ['chave','key','id','nome','name','hostname'].includes(key));
  if (keyIndex < 0) throw new Error('Inclua uma coluna Chave, ID, Nome ou Hostname para localizar os objetos.');
  const fieldColumns = headers.map((header, index) => ({ index, header, key: safeField(header) })).filter((item) => item.index !== keyIndex && item.key);
  if (fieldColumns.length === 0) throw new Error('O CSV não possui campos de dados para aplicar.');
  const next = structuredClone(page); let matched = 0; const unmatched: string[] = [];
  const lookup = (raw: string) => {
    const value = raw.trim(); const folded = value.toLocaleLowerCase('pt-BR');
    return next.nodes.find((node) => node.id === value || node.text.trim().toLocaleLowerCase('pt-BR') === folded || String(node.data.hostname ?? '').trim().toLocaleLowerCase('pt-BR') === folded || String(node.data.name ?? '').trim().toLocaleLowerCase('pt-BR') === folded);
  };
  for (const row of rows.slice(1)) {
    const key = String(row[keyIndex] ?? '').trim(); if (!key) continue;
    const node = lookup(key); if (!node) { unmatched.push(key); continue; }
    const data = { ...node.data };
    for (const field of fieldColumns) data[field.key!] = String(row[field.index] ?? '').trim();
    node.data = data; matched += 1;
  }
  return { page: next, matched, unmatched: unmatched.slice(0, 100), fields: fieldColumns.map((item) => item.key!) };
}
